<template>
   <div class="advMain" id="page5">
     <div class="leftBlock">
       <h3 class="title">让专利防伪更官方</h3>
       <p class="message">
         涿溪防窜货防伪技术经过专利认证，同时对接国家标识，由国家工信部授权，每一个防伪码都是全球唯一，让产品造假商、防伪码造假商无所遁形。
       </p>
       <div class="buttonWrap"><Mybutton @clickFn="showForm">了解专利防伪</Mybutton></div>
     </div>
     <div class="rightBlock">
       <transition name="fdj">
         <img class="fdj" v-show="officShow" src="../assets/images/fdj.png" />
       </transition>
       <!-- <transition name="iconImg"> -->
        <img class="zl" v-show="officShow" src="../assets/images/zl.png" />
       <!-- </transition> -->
       <!-- <transition name="iconImg"> -->
        <img class="tp" v-show="officShow" src="../assets/images/tp.png" />
       <!-- </transition> -->
       <!-- <transition name="iconImg"> -->
        <img class="bz" v-show="officShow" src="../assets/images/bz.png" />
       <!-- </transition> -->
     </div>
   </div>
</template>
<script>
import Mybutton from './Mybutton'
export default {
  name: 'codeOffic',
  components: {
    Mybutton
  },
  props:{
    officShow: Boolean,
  },
  data () {
    return {

    }
  },
  methods:{
    showForm() {
      this.$emit('changeVisible', true)
    }
  }
}
</script>
<style scoped lang="scss">
/**放大镜动画**/
.fdj{
  position: absolute;
  left: 411px;
  top: 0;
}

.fdj-enter-active {
  animation: fdj-in-out 2s;
  animation-delay: 0.3s;
}
.fdj-leave-active {
  // animation: fdj-in-out .3s reverse;
  animation-delay: 0;
}

@keyframes fdj-in-out {
  0% {
    left: 411px;
    top: 0;
  }
  10%{
    left: 250px;
    top: 50px;
  }
  30%{
    left: 400px;
    top: 10px;
  }
  60%{
    left: 230px;
    top: 200px;
  }
  90%{
    left: 300px;
    top: 250px;
  }
  100%{
    left: 411px;
    top: 0;
  }
}


/**图标动画**/
.zl {
  position: absolute;
  left: 140px;
  top: 208px;
  animation: icon-in-out 2s .8s;
  opacity: 0;
  animation-fill-mode: forwards;
}
.tp {
 position: absolute;
 left: 0;
 bottom: 0;
 opacity: 0;
 animation: icon-in-out 2s .8s;
 animation-fill-mode: forwards;
}
.bz {
 position: absolute;
 right: 44px;
 top: 228px;
 opacity: 0;
 animation: icon-in-out 2s .8s;
 animation-fill-mode: forwards;
}

.iconImg-enter-active {
  animation: icon-in-out .5s;
  animation-delay: .8s;
}
.iconImg-leave-active {
  animation: icon-in-out .3s reverse;
  animation-delay: 0;
}
@keyframes icon-in-out {
  0%{
    opacity: 0;
    transform: scale(0.2)
  }
  100%{
    opacity: 1;
    transform: scale(1)
  }
}
  .advMain{
    padding: 12% 100px 75px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    background: #F7F6FA;
    .leftBlock{
      .title{
        font-size: 40px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: normal;
        color: #1F2329;
        line-height: 56px;
      }
      .message{
        font-size: 18px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: normal;
        color: #36444D;
        line-height: 28px;
        width: 400px;
      }
      .buttonWrap{
        margin-top: 50px;
      }
    }
    .rightBlock{
      width: 480px;
      height: 362px;
      background: url('../assets/images/bg_4.png') top left no-repeat;
      position: relative;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CodeOffic.vue